<div class="liberar-compra-convites-dialog">
  <div class="liberar-compra-convites-dialog__form">
    <div class="new-form-control-sm liberar-compra-convites-dialog__field">
      <label for="liberarCompraData">Data (início)</label>

      <p-calendar
        inputId="liberarCompraData"
        name="liberarCompraData"
        [(ngModel)]="liberarCompraDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        appendTo="body"
        [yearRange]="'2000:2055'"
        icon="pi pi-calendar enlarged-icon"

      ></p-calendar>
    </div>
    <div class="new-form-control-sm liberar-compra-convites-dialog__field">
      <label for="liberarCompraNumero">Nº adicionais de convite</label>
      <p-inputNumber
        inputId="liberarCompraNumero"
        name="liberarCompraNumero"
        [(ngModel)]="liberarCompraQty"
        [min]="1"
        [showButtons]="true"
        [useGrouping]="false"
        placeholder="Quantidade"
        styleClass="liberar-compra-convites-dialog__qty"
      ></p-inputNumber>
    </div>
  </div>
  <div class="liberar-compra-convites-dialog__footer">
    <button type="button" class="new-easymarine disabled" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="new-easymarine primary" (click)="confirm()">
      Confirmar
    </button>
  </div>
</div>
